<ng-container *ngIf="tableViewModel$ | async as table">
  <app-grid-users-list
    [sortOptions]="SORT_OPTIONS"
    [currentSortCategory]="currentSortCategory"
    [ascending]="ascending"
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalCount]="table.totalCount"
    (pageChange)="onPageChanged($event)"
    [pagination]="table.pagination"
    [constructorData]="table.data"
    (toggleSorting)="onSortParamChanged($event)"
    (toggleSortingByType)="toggleSortingOrderByType($event)"
    (action)="onTableAction($event)"
  ></app-grid-users-list>
</ng-container>
